import React, { createContext, useContext, useMemo } from "react";

const PreviewModeContext = createContext<boolean>(false);

interface PreviewModeProviderProps {
  value?: boolean;
  children: React.ReactNode;
}

export function PreviewModeProvider({ value = false, children }: PreviewModeProviderProps) {
  const memoizedValue = useMemo(() => Boolean(value), [value]);
  return (
    <PreviewModeContext.Provider value={memoizedValue}>
      {children}
    </PreviewModeContext.Provider>
  );
}

export function usePreviewMode() {
  return useContext(PreviewModeContext);
}
